export const countries = {
    AF: {
        alpha2Code: 'AF',
        alpha3Code: 'AFG',
        currencyCode: 'AFN',
        currencySymbol: '؋',
        callingCodes: ['93'],
    },
    AX: {
        alpha2Code: 'AX',
        alpha3Code: 'ALA',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['358'],
    },
    AL: {
        alpha2Code: 'AL',
        alpha3Code: 'ALB',
        currencyCode: 'ALL',
        currencySymbol: 'L',
        callingCodes: ['355'],
    },
    DZ: {
        alpha2Code: 'DZ',
        alpha3Code: 'DZA',
        currencyCode: 'DZD',
        currencySymbol: 'د.ج',
        callingCodes: ['213'],
    },
    AS: {
        alpha2Code: 'AS',
        alpha3Code: 'ASM',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1684'],
    },
    AD: {
        alpha2Code: 'AD',
        alpha3Code: 'AND',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['376'],
    },
    AO: {
        alpha2Code: 'AO',
        alpha3Code: 'AGO',
        currencyCode: 'AOA',
        currencySymbol: 'Kz',
        callingCodes: ['244'],
    },
    AI: {
        alpha2Code: 'AI',
        alpha3Code: 'AIA',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1264'],
    },
    AQ: {
        alpha2Code: 'AQ',
        alpha3Code: 'ATA',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['672'],
    },
    AG: {
        alpha2Code: 'AG',
        alpha3Code: 'ATG',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1268'],
    },
    AR: {
        alpha2Code: 'AR',
        alpha3Code: 'ARG',
        currencyCode: 'ARS',
        currencySymbol: '$',
        callingCodes: ['54'],
    },
    AM: {
        alpha2Code: 'AM',
        alpha3Code: 'ARM',
        currencyCode: 'AMD',
        currencySymbol: null,
        callingCodes: ['374'],
    },
    AW: {
        alpha2Code: 'AW',
        alpha3Code: 'ABW',
        currencyCode: 'AWG',
        currencySymbol: 'ƒ',
        callingCodes: ['297'],
    },
    AU: {
        alpha2Code: 'AU',
        alpha3Code: 'AUS',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['61'],
    },
    AT: {
        alpha2Code: 'AT',
        alpha3Code: 'AUT',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['43'],
    },
    AZ: {
        alpha2Code: 'AZ',
        alpha3Code: 'AZE',
        currencyCode: 'AZN',
        currencySymbol: null,
        callingCodes: ['994'],
    },
    BS: {
        alpha2Code: 'BS',
        alpha3Code: 'BHS',
        currencyCode: 'BSD',
        currencySymbol: '$',
        callingCodes: ['1242'],
    },
    BH: {
        alpha2Code: 'BH',
        alpha3Code: 'BHR',
        currencyCode: 'BHD',
        currencySymbol: '.د.ب',
        callingCodes: ['973'],
    },
    BD: {
        alpha2Code: 'BD',
        alpha3Code: 'BGD',
        currencyCode: 'BDT',
        currencySymbol: '৳',
        callingCodes: ['880'],
    },
    BB: {
        alpha2Code: 'BB',
        alpha3Code: 'BRB',
        currencyCode: 'BBD',
        currencySymbol: '$',
        callingCodes: ['1246'],
    },
    BY: {
        alpha2Code: 'BY',
        alpha3Code: 'BLR',
        currencyCode: 'BYN',
        currencySymbol: 'Br',
        callingCodes: ['375'],
    },
    BE: {
        alpha2Code: 'BE',
        alpha3Code: 'BEL',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['32'],
    },
    BZ: {
        alpha2Code: 'BZ',
        alpha3Code: 'BLZ',
        currencyCode: 'BZD',
        currencySymbol: '$',
        callingCodes: ['501'],
    },
    BJ: {
        alpha2Code: 'BJ',
        alpha3Code: 'BEN',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['229'],
    },
    BM: {
        alpha2Code: 'BM',
        alpha3Code: 'BMU',
        currencyCode: 'BMD',
        currencySymbol: '$',
        callingCodes: ['1441'],
    },
    BT: {
        alpha2Code: 'BT',
        alpha3Code: 'BTN',
        currencyCode: 'BTN',
        currencySymbol: 'Nu.',
        callingCodes: ['975'],
    },
    BO: {
        alpha2Code: 'BO',
        alpha3Code: 'BOL',
        currencyCode: 'BOB',
        currencySymbol: 'Bs.',
        callingCodes: ['591'],
    },
    BQ: {
        alpha2Code: 'BQ',
        alpha3Code: 'BES',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['5997'],
    },
    BA: {
        alpha2Code: 'BA',
        alpha3Code: 'BIH',
        currencyCode: 'BAM',
        currencySymbol: null,
        callingCodes: ['387'],
    },
    BW: {
        alpha2Code: 'BW',
        alpha3Code: 'BWA',
        currencyCode: 'BWP',
        currencySymbol: 'P',
        callingCodes: ['267'],
    },
    BV: {
        alpha2Code: 'BV',
        alpha3Code: 'BVT',
        currencyCode: 'NOK',
        currencySymbol: 'kr',
        callingCodes: [''],
    },
    BR: {
        alpha2Code: 'BR',
        alpha3Code: 'BRA',
        currencyCode: 'BRL',
        currencySymbol: 'R$',
        callingCodes: ['55'],
    },
    IO: {
        alpha2Code: 'IO',
        alpha3Code: 'IOT',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['246'],
    },
    UM: {
        alpha2Code: 'UM',
        alpha3Code: 'UMI',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: [''],
    },
    VG: {
        alpha2Code: 'VG',
        alpha3Code: 'VGB',
        currencyCode: null,
        currencySymbol: '$',
        callingCodes: ['1284'],
    },
    VI: {
        alpha2Code: 'VI',
        alpha3Code: 'VIR',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1 340'],
    },
    BN: {
        alpha2Code: 'BN',
        alpha3Code: 'BRN',
        currencyCode: 'BND',
        currencySymbol: '$',
        callingCodes: ['673'],
    },
    BG: {
        alpha2Code: 'BG',
        alpha3Code: 'BGR',
        currencyCode: 'BGN',
        currencySymbol: 'лв',
        callingCodes: ['359'],
    },
    BF: {
        alpha2Code: 'BF',
        alpha3Code: 'BFA',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['226'],
    },
    BI: {
        alpha2Code: 'BI',
        alpha3Code: 'BDI',
        currencyCode: 'BIF',
        currencySymbol: 'Fr',
        callingCodes: ['257'],
    },
    KH: {
        alpha2Code: 'KH',
        alpha3Code: 'KHM',
        currencyCode: 'KHR',
        currencySymbol: '៛',
        callingCodes: ['855'],
    },
    CM: {
        alpha2Code: 'CM',
        alpha3Code: 'CMR',
        currencyCode: 'XAF',
        currencySymbol: 'Fr',
        callingCodes: ['237'],
    },
    CA: {
        alpha2Code: 'CA',
        alpha3Code: 'CAN',
        currencyCode: 'CAD',
        currencySymbol: '$',
        callingCodes: ['1'],
    },
    CV: {
        alpha2Code: 'CV',
        alpha3Code: 'CPV',
        currencyCode: 'CVE',
        currencySymbol: 'Esc',
        callingCodes: ['238'],
    },
    KY: {
        alpha2Code: 'KY',
        alpha3Code: 'CYM',
        currencyCode: 'KYD',
        currencySymbol: '$',
        callingCodes: ['1345'],
    },
    CF: {
        alpha2Code: 'CF',
        alpha3Code: 'CAF',
        currencyCode: 'XAF',
        currencySymbol: 'Fr',
        callingCodes: ['236'],
    },
    TD: {
        alpha2Code: 'TD',
        alpha3Code: 'TCD',
        currencyCode: 'XAF',
        currencySymbol: 'Fr',
        callingCodes: ['235'],
    },
    CL: {
        alpha2Code: 'CL',
        alpha3Code: 'CHL',
        currencyCode: 'CLP',
        currencySymbol: '$',
        callingCodes: ['56'],
    },
    CN: {
        alpha2Code: 'CN',
        alpha3Code: 'CHN',
        currencyCode: 'CNY',
        currencySymbol: '¥',
        callingCodes: ['86'],
    },
    CX: {
        alpha2Code: 'CX',
        alpha3Code: 'CXR',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['61'],
    },
    CC: {
        alpha2Code: 'CC',
        alpha3Code: 'CCK',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['61'],
    },
    CO: {
        alpha2Code: 'CO',
        alpha3Code: 'COL',
        currencyCode: 'COP',
        currencySymbol: '$',
        callingCodes: ['57'],
    },
    KM: {
        alpha2Code: 'KM',
        alpha3Code: 'COM',
        currencyCode: 'KMF',
        currencySymbol: 'Fr',
        callingCodes: ['269'],
    },
    CG: {
        alpha2Code: 'CG',
        alpha3Code: 'COG',
        currencyCode: 'XAF',
        currencySymbol: 'Fr',
        callingCodes: ['242'],
    },
    CD: {
        alpha2Code: 'CD',
        alpha3Code: 'COD',
        currencyCode: 'CDF',
        currencySymbol: 'Fr',
        callingCodes: ['243'],
    },
    CK: {
        alpha2Code: 'CK',
        alpha3Code: 'COK',
        currencyCode: 'NZD',
        currencySymbol: '$',
        callingCodes: ['682'],
    },
    CR: {
        alpha2Code: 'CR',
        alpha3Code: 'CRI',
        currencyCode: 'CRC',
        currencySymbol: '₡',
        callingCodes: ['506'],
    },
    HR: {
        alpha2Code: 'HR',
        alpha3Code: 'HRV',
        currencyCode: 'HRK',
        currencySymbol: 'kn',
        callingCodes: ['385'],
    },
    CU: {
        alpha2Code: 'CU',
        alpha3Code: 'CUB',
        currencyCode: 'CUC',
        currencySymbol: '$',
        callingCodes: ['53'],
    },
    CW: {
        alpha2Code: 'CW',
        alpha3Code: 'CUW',
        currencyCode: 'ANG',
        currencySymbol: 'ƒ',
        callingCodes: ['599'],
    },
    CY: {
        alpha2Code: 'CY',
        alpha3Code: 'CYP',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['357'],
    },
    CZ: {
        alpha2Code: 'CZ',
        alpha3Code: 'CZE',
        currencyCode: 'CZK',
        currencySymbol: 'Kč',
        callingCodes: ['420'],
    },
    DK: {
        alpha2Code: 'DK',
        alpha3Code: 'DNK',
        currencyCode: 'DKK',
        currencySymbol: 'kr',
        callingCodes: ['45'],
    },
    DJ: {
        alpha2Code: 'DJ',
        alpha3Code: 'DJI',
        currencyCode: 'DJF',
        currencySymbol: 'Fr',
        callingCodes: ['253'],
    },
    DM: {
        alpha2Code: 'DM',
        alpha3Code: 'DMA',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1767'],
    },
    DO: {
        alpha2Code: 'DO',
        alpha3Code: 'DOM',
        currencyCode: 'DOP',
        currencySymbol: '$',
        callingCodes: ['1809', '1829', '1849'],
    },
    EC: {
        alpha2Code: 'EC',
        alpha3Code: 'ECU',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['593'],
    },
    EG: {
        alpha2Code: 'EG',
        alpha3Code: 'EGY',
        currencyCode: 'EGP',
        currencySymbol: '£',
        callingCodes: ['20'],
    },
    SV: {
        alpha2Code: 'SV',
        alpha3Code: 'SLV',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['503'],
    },
    GQ: {
        alpha2Code: 'GQ',
        alpha3Code: 'GNQ',
        currencyCode: 'XAF',
        currencySymbol: 'Fr',
        callingCodes: ['240'],
    },
    ER: {
        alpha2Code: 'ER',
        alpha3Code: 'ERI',
        currencyCode: 'ERN',
        currencySymbol: 'Nfk',
        callingCodes: ['291'],
    },
    EE: {
        alpha2Code: 'EE',
        alpha3Code: 'EST',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['372'],
    },
    ET: {
        alpha2Code: 'ET',
        alpha3Code: 'ETH',
        currencyCode: 'ETB',
        currencySymbol: 'Br',
        callingCodes: ['251'],
    },
    FK: {
        alpha2Code: 'FK',
        alpha3Code: 'FLK',
        currencyCode: 'FKP',
        currencySymbol: '£',
        callingCodes: ['500'],
    },
    FO: {
        alpha2Code: 'FO',
        alpha3Code: 'FRO',
        currencyCode: 'DKK',
        currencySymbol: 'kr',
        callingCodes: ['298'],
    },
    FJ: {
        alpha2Code: 'FJ',
        alpha3Code: 'FJI',
        currencyCode: 'FJD',
        currencySymbol: '$',
        callingCodes: ['679'],
    },
    FI: {
        alpha2Code: 'FI',
        alpha3Code: 'FIN',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['358'],
    },
    FR: {
        alpha2Code: 'FR',
        alpha3Code: 'FRA',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['33'],
    },
    GF: {
        alpha2Code: 'GF',
        alpha3Code: 'GUF',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['594'],
    },
    PF: {
        alpha2Code: 'PF',
        alpha3Code: 'PYF',
        currencyCode: 'XPF',
        currencySymbol: 'Fr',
        callingCodes: ['689'],
    },
    TF: {
        alpha2Code: 'TF',
        alpha3Code: 'ATF',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: [''],
    },
    GA: {
        alpha2Code: 'GA',
        alpha3Code: 'GAB',
        currencyCode: 'XAF',
        currencySymbol: 'Fr',
        callingCodes: ['241'],
    },
    GM: {
        alpha2Code: 'GM',
        alpha3Code: 'GMB',
        currencyCode: 'GMD',
        currencySymbol: 'D',
        callingCodes: ['220'],
    },
    GE: {
        alpha2Code: 'GE',
        alpha3Code: 'GEO',
        currencyCode: 'GEL',
        currencySymbol: 'ლ',
        callingCodes: ['995'],
    },
    DE: {
        alpha2Code: 'DE',
        alpha3Code: 'DEU',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['49'],
    },
    GH: {
        alpha2Code: 'GH',
        alpha3Code: 'GHA',
        currencyCode: 'GHS',
        currencySymbol: '₵',
        callingCodes: ['233'],
    },
    GI: {
        alpha2Code: 'GI',
        alpha3Code: 'GIB',
        currencyCode: 'GIP',
        currencySymbol: '£',
        callingCodes: ['350'],
    },
    GR: {
        alpha2Code: 'GR',
        alpha3Code: 'GRC',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['30'],
    },
    GL: {
        alpha2Code: 'GL',
        alpha3Code: 'GRL',
        currencyCode: 'DKK',
        currencySymbol: 'kr',
        callingCodes: ['299'],
    },
    GD: {
        alpha2Code: 'GD',
        alpha3Code: 'GRD',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1473'],
    },
    GP: {
        alpha2Code: 'GP',
        alpha3Code: 'GLP',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['590'],
    },
    GU: {
        alpha2Code: 'GU',
        alpha3Code: 'GUM',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1671'],
    },
    GT: {
        alpha2Code: 'GT',
        alpha3Code: 'GTM',
        currencyCode: 'GTQ',
        currencySymbol: 'Q',
        callingCodes: ['502'],
    },
    GG: {
        alpha2Code: 'GG',
        alpha3Code: 'GGY',
        currencyCode: 'GBP',
        currencySymbol: '£',
        callingCodes: ['44'],
    },
    GN: {
        alpha2Code: 'GN',
        alpha3Code: 'GIN',
        currencyCode: 'GNF',
        currencySymbol: 'Fr',
        callingCodes: ['224'],
    },
    GW: {
        alpha2Code: 'GW',
        alpha3Code: 'GNB',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['245'],
    },
    GY: {
        alpha2Code: 'GY',
        alpha3Code: 'GUY',
        currencyCode: 'GYD',
        currencySymbol: '$',
        callingCodes: ['592'],
    },
    HT: {
        alpha2Code: 'HT',
        alpha3Code: 'HTI',
        currencyCode: 'HTG',
        currencySymbol: 'G',
        callingCodes: ['509'],
    },
    HM: {
        alpha2Code: 'HM',
        alpha3Code: 'HMD',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: [''],
    },
    VA: {
        alpha2Code: 'VA',
        alpha3Code: 'VAT',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['379'],
    },
    HN: {
        alpha2Code: 'HN',
        alpha3Code: 'HND',
        currencyCode: 'HNL',
        currencySymbol: 'L',
        callingCodes: ['504'],
    },
    HK: {
        alpha2Code: 'HK',
        alpha3Code: 'HKG',
        currencyCode: 'HKD',
        currencySymbol: '$',
        callingCodes: ['852'],
    },
    HU: {
        alpha2Code: 'HU',
        alpha3Code: 'HUN',
        currencyCode: 'HUF',
        currencySymbol: 'Ft',
        callingCodes: ['36'],
    },
    IS: {
        alpha2Code: 'IS',
        alpha3Code: 'ISL',
        currencyCode: 'ISK',
        currencySymbol: 'kr',
        callingCodes: ['354'],
    },
    IN: {
        alpha2Code: 'IN',
        alpha3Code: 'IND',
        currencyCode: 'INR',
        currencySymbol: '₹',
        callingCodes: ['91'],
    },
    ID: {
        alpha2Code: 'ID',
        alpha3Code: 'IDN',
        currencyCode: 'IDR',
        currencySymbol: 'Rp',
        callingCodes: ['62'],
    },
    CI: {
        alpha2Code: 'CI',
        alpha3Code: 'CIV',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['225'],
    },
    IR: {
        alpha2Code: 'IR',
        alpha3Code: 'IRN',
        currencyCode: 'IRR',
        currencySymbol: '﷼',
        callingCodes: ['98'],
    },
    IQ: {
        alpha2Code: 'IQ',
        alpha3Code: 'IRQ',
        currencyCode: 'IQD',
        currencySymbol: 'ع.د',
        callingCodes: ['964'],
    },
    IE: {
        alpha2Code: 'IE',
        alpha3Code: 'IRL',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['353'],
    },
    IM: {
        alpha2Code: 'IM',
        alpha3Code: 'IMN',
        currencyCode: 'GBP',
        currencySymbol: '£',
        callingCodes: ['44'],
    },
    IL: {
        alpha2Code: 'IL',
        alpha3Code: 'ISR',
        currencyCode: 'ILS',
        currencySymbol: '₪',
        callingCodes: ['972'],
    },
    IT: {
        alpha2Code: 'IT',
        alpha3Code: 'ITA',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['39'],
    },
    JM: {
        alpha2Code: 'JM',
        alpha3Code: 'JAM',
        currencyCode: 'JMD',
        currencySymbol: '$',
        callingCodes: ['1876'],
    },
    JP: {
        alpha2Code: 'JP',
        alpha3Code: 'JPN',
        currencyCode: 'JPY',
        currencySymbol: '¥',
        callingCodes: ['81'],
    },
    JE: {
        alpha2Code: 'JE',
        alpha3Code: 'JEY',
        currencyCode: 'GBP',
        currencySymbol: '£',
        callingCodes: ['44'],
    },
    JO: {
        alpha2Code: 'JO',
        alpha3Code: 'JOR',
        currencyCode: 'JOD',
        currencySymbol: 'د.ا',
        callingCodes: ['962'],
    },
    KZ: {
        alpha2Code: 'KZ',
        alpha3Code: 'KAZ',
        currencyCode: 'KZT',
        currencySymbol: null,
        callingCodes: ['76', '77'],
    },
    KE: {
        alpha2Code: 'KE',
        alpha3Code: 'KEN',
        currencyCode: 'KES',
        currencySymbol: 'Sh',
        callingCodes: ['254'],
    },
    KI: {
        alpha2Code: 'KI',
        alpha3Code: 'KIR',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['686'],
    },
    KW: {
        alpha2Code: 'KW',
        alpha3Code: 'KWT',
        currencyCode: 'KWD',
        currencySymbol: 'د.ك',
        callingCodes: ['965'],
    },
    KG: {
        alpha2Code: 'KG',
        alpha3Code: 'KGZ',
        currencyCode: 'KGS',
        currencySymbol: 'с',
        callingCodes: ['996'],
    },
    LA: {
        alpha2Code: 'LA',
        alpha3Code: 'LAO',
        currencyCode: 'LAK',
        currencySymbol: '₭',
        callingCodes: ['856'],
    },
    LV: {
        alpha2Code: 'LV',
        alpha3Code: 'LVA',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['371'],
    },
    LB: {
        alpha2Code: 'LB',
        alpha3Code: 'LBN',
        currencyCode: 'LBP',
        currencySymbol: 'ل.ل',
        callingCodes: ['961'],
    },
    LS: {
        alpha2Code: 'LS',
        alpha3Code: 'LSO',
        currencyCode: 'LSL',
        currencySymbol: 'L',
        callingCodes: ['266'],
    },
    LR: {
        alpha2Code: 'LR',
        alpha3Code: 'LBR',
        currencyCode: 'LRD',
        currencySymbol: '$',
        callingCodes: ['231'],
    },
    LY: {
        alpha2Code: 'LY',
        alpha3Code: 'LBY',
        currencyCode: 'LYD',
        currencySymbol: 'ل.د',
        callingCodes: ['218'],
    },
    LI: {
        alpha2Code: 'LI',
        alpha3Code: 'LIE',
        currencyCode: 'CHF',
        currencySymbol: 'Fr',
        callingCodes: ['423'],
    },
    LT: {
        alpha2Code: 'LT',
        alpha3Code: 'LTU',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['370'],
    },
    LU: {
        alpha2Code: 'LU',
        alpha3Code: 'LUX',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['352'],
    },
    MO: {
        alpha2Code: 'MO',
        alpha3Code: 'MAC',
        currencyCode: 'MOP',
        currencySymbol: 'P',
        callingCodes: ['853'],
    },
    MK: {
        alpha2Code: 'MK',
        alpha3Code: 'MKD',
        currencyCode: 'MKD',
        currencySymbol: 'ден',
        callingCodes: ['389'],
    },
    MG: {
        alpha2Code: 'MG',
        alpha3Code: 'MDG',
        currencyCode: 'MGA',
        currencySymbol: 'Ar',
        callingCodes: ['261'],
    },
    MW: {
        alpha2Code: 'MW',
        alpha3Code: 'MWI',
        currencyCode: 'MWK',
        currencySymbol: 'MK',
        callingCodes: ['265'],
    },
    MY: {
        alpha2Code: 'MY',
        alpha3Code: 'MYS',
        currencyCode: 'MYR',
        currencySymbol: 'RM',
        callingCodes: ['60'],
    },
    MV: {
        alpha2Code: 'MV',
        alpha3Code: 'MDV',
        currencyCode: 'MVR',
        currencySymbol: '.ރ',
        callingCodes: ['960'],
    },
    ML: {
        alpha2Code: 'ML',
        alpha3Code: 'MLI',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['223'],
    },
    MT: {
        alpha2Code: 'MT',
        alpha3Code: 'MLT',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['356'],
    },
    MH: {
        alpha2Code: 'MH',
        alpha3Code: 'MHL',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['692'],
    },
    MQ: {
        alpha2Code: 'MQ',
        alpha3Code: 'MTQ',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['596'],
    },
    MR: {
        alpha2Code: 'MR',
        alpha3Code: 'MRT',
        currencyCode: 'MRO',
        currencySymbol: 'UM',
        callingCodes: ['222'],
    },
    MU: {
        alpha2Code: 'MU',
        alpha3Code: 'MUS',
        currencyCode: 'MUR',
        currencySymbol: '₨',
        callingCodes: ['230'],
    },
    YT: {
        alpha2Code: 'YT',
        alpha3Code: 'MYT',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['262'],
    },
    MX: {
        alpha2Code: 'MX',
        alpha3Code: 'MEX',
        currencyCode: 'MXN',
        currencySymbol: '$',
        callingCodes: ['52'],
    },
    FM: {
        alpha2Code: 'FM',
        alpha3Code: 'FSM',
        currencyCode: null,
        currencySymbol: '$',
        callingCodes: ['691'],
    },
    MD: {
        alpha2Code: 'MD',
        alpha3Code: 'MDA',
        currencyCode: 'MDL',
        currencySymbol: 'L',
        callingCodes: ['373'],
    },
    MC: {
        alpha2Code: 'MC',
        alpha3Code: 'MCO',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['377'],
    },
    MN: {
        alpha2Code: 'MN',
        alpha3Code: 'MNG',
        currencyCode: 'MNT',
        currencySymbol: '₮',
        callingCodes: ['976'],
    },
    ME: {
        alpha2Code: 'ME',
        alpha3Code: 'MNE',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['382'],
    },
    MS: {
        alpha2Code: 'MS',
        alpha3Code: 'MSR',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1664'],
    },
    MA: {
        alpha2Code: 'MA',
        alpha3Code: 'MAR',
        currencyCode: 'MAD',
        currencySymbol: 'د.م.',
        callingCodes: ['212'],
    },
    MZ: {
        alpha2Code: 'MZ',
        alpha3Code: 'MOZ',
        currencyCode: 'MZN',
        currencySymbol: 'MT',
        callingCodes: ['258'],
    },
    MM: {
        alpha2Code: 'MM',
        alpha3Code: 'MMR',
        currencyCode: 'MMK',
        currencySymbol: 'Ks',
        callingCodes: ['95'],
    },
    NA: {
        alpha2Code: 'NA',
        alpha3Code: 'NAM',
        currencyCode: 'NAD',
        currencySymbol: '$',
        callingCodes: ['264'],
    },
    NR: {
        alpha2Code: 'NR',
        alpha3Code: 'NRU',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['674'],
    },
    NP: {
        alpha2Code: 'NP',
        alpha3Code: 'NPL',
        currencyCode: 'NPR',
        currencySymbol: '₨',
        callingCodes: ['977'],
    },
    NL: {
        alpha2Code: 'NL',
        alpha3Code: 'NLD',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['31'],
    },
    NC: {
        alpha2Code: 'NC',
        alpha3Code: 'NCL',
        currencyCode: 'XPF',
        currencySymbol: 'Fr',
        callingCodes: ['687'],
    },
    NZ: {
        alpha2Code: 'NZ',
        alpha3Code: 'NZL',
        currencyCode: 'NZD',
        currencySymbol: '$',
        callingCodes: ['64'],
    },
    NI: {
        alpha2Code: 'NI',
        alpha3Code: 'NIC',
        currencyCode: 'NIO',
        currencySymbol: 'C$',
        callingCodes: ['505'],
    },
    NE: {
        alpha2Code: 'NE',
        alpha3Code: 'NER',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['227'],
    },
    NG: {
        alpha2Code: 'NG',
        alpha3Code: 'NGA',
        currencyCode: 'NGN',
        currencySymbol: '₦',
        callingCodes: ['234'],
    },
    NU: {
        alpha2Code: 'NU',
        alpha3Code: 'NIU',
        currencyCode: 'NZD',
        currencySymbol: '$',
        callingCodes: ['683'],
    },
    NF: {
        alpha2Code: 'NF',
        alpha3Code: 'NFK',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['672'],
    },
    KP: {
        alpha2Code: 'KP',
        alpha3Code: 'PRK',
        currencyCode: 'KPW',
        currencySymbol: '₩',
        callingCodes: ['850'],
    },
    MP: {
        alpha2Code: 'MP',
        alpha3Code: 'MNP',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1670'],
    },
    NO: {
        alpha2Code: 'NO',
        alpha3Code: 'NOR',
        currencyCode: 'NOK',
        currencySymbol: 'kr',
        callingCodes: ['47'],
    },
    OM: {
        alpha2Code: 'OM',
        alpha3Code: 'OMN',
        currencyCode: 'OMR',
        currencySymbol: 'ر.ع.',
        callingCodes: ['968'],
    },
    PK: {
        alpha2Code: 'PK',
        alpha3Code: 'PAK',
        currencyCode: 'PKR',
        currencySymbol: '₨',
        callingCodes: ['92'],
    },
    PW: {
        alpha2Code: 'PW',
        alpha3Code: 'PLW',
        currencyCode: '(none)',
        currencySymbol: '$',
        callingCodes: ['680'],
    },
    PS: {
        alpha2Code: 'PS',
        alpha3Code: 'PSE',
        currencyCode: 'ILS',
        currencySymbol: '₪',
        callingCodes: ['970'],
    },
    PA: {
        alpha2Code: 'PA',
        alpha3Code: 'PAN',
        currencyCode: 'PAB',
        currencySymbol: 'B/.',
        callingCodes: ['507'],
    },
    PG: {
        alpha2Code: 'PG',
        alpha3Code: 'PNG',
        currencyCode: 'PGK',
        currencySymbol: 'K',
        callingCodes: ['675'],
    },
    PY: {
        alpha2Code: 'PY',
        alpha3Code: 'PRY',
        currencyCode: 'PYG',
        currencySymbol: '₲',
        callingCodes: ['595'],
    },
    PE: {
        alpha2Code: 'PE',
        alpha3Code: 'PER',
        currencyCode: 'PEN',
        currencySymbol: 'S/.',
        callingCodes: ['51'],
    },
    PH: {
        alpha2Code: 'PH',
        alpha3Code: 'PHL',
        currencyCode: 'PHP',
        currencySymbol: '₱',
        callingCodes: ['63'],
    },
    PN: {
        alpha2Code: 'PN',
        alpha3Code: 'PCN',
        currencyCode: 'NZD',
        currencySymbol: '$',
        callingCodes: ['64'],
    },
    PL: {
        alpha2Code: 'PL',
        alpha3Code: 'POL',
        currencyCode: 'PLN',
        currencySymbol: 'zł',
        callingCodes: ['48'],
    },
    PT: {
        alpha2Code: 'PT',
        alpha3Code: 'PRT',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['351'],
    },
    PR: {
        alpha2Code: 'PR',
        alpha3Code: 'PRI',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1787', '1939'],
    },
    QA: {
        alpha2Code: 'QA',
        alpha3Code: 'QAT',
        currencyCode: 'QAR',
        currencySymbol: 'ر.ق',
        callingCodes: ['974'],
    },
    XK: {
        alpha2Code: 'XK',
        alpha3Code: 'KOS',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['383'],
    },
    RE: {
        alpha2Code: 'RE',
        alpha3Code: 'REU',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['262'],
    },
    RO: {
        alpha2Code: 'RO',
        alpha3Code: 'ROU',
        currencyCode: 'RON',
        currencySymbol: 'lei',
        callingCodes: ['40'],
    },
    RU: {
        alpha2Code: 'RU',
        alpha3Code: 'RUS',
        currencyCode: 'RUB',
        currencySymbol: '₽',
        callingCodes: ['7'],
    },
    RW: {
        alpha2Code: 'RW',
        alpha3Code: 'RWA',
        currencyCode: 'RWF',
        currencySymbol: 'Fr',
        callingCodes: ['250'],
    },
    BL: {
        alpha2Code: 'BL',
        alpha3Code: 'BLM',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['590'],
    },
    SH: {
        alpha2Code: 'SH',
        alpha3Code: 'SHN',
        currencyCode: 'SHP',
        currencySymbol: '£',
        callingCodes: ['290'],
    },
    KN: {
        alpha2Code: 'KN',
        alpha3Code: 'KNA',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1869'],
    },
    LC: {
        alpha2Code: 'LC',
        alpha3Code: 'LCA',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1758'],
    },
    MF: {
        alpha2Code: 'MF',
        alpha3Code: 'MAF',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['590'],
    },
    PM: {
        alpha2Code: 'PM',
        alpha3Code: 'SPM',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['508'],
    },
    VC: {
        alpha2Code: 'VC',
        alpha3Code: 'VCT',
        currencyCode: 'XCD',
        currencySymbol: '$',
        callingCodes: ['1784'],
    },
    WS: {
        alpha2Code: 'WS',
        alpha3Code: 'WSM',
        currencyCode: 'WST',
        currencySymbol: 'T',
        callingCodes: ['685'],
    },
    SM: {
        alpha2Code: 'SM',
        alpha3Code: 'SMR',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['378'],
    },
    ST: {
        alpha2Code: 'ST',
        alpha3Code: 'STP',
        currencyCode: 'STD',
        currencySymbol: 'Db',
        callingCodes: ['239'],
    },
    SA: {
        alpha2Code: 'SA',
        alpha3Code: 'SAU',
        currencyCode: 'SAR',
        currencySymbol: 'ر.س',
        callingCodes: ['966'],
    },
    SN: {
        alpha2Code: 'SN',
        alpha3Code: 'SEN',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['221'],
    },
    RS: {
        alpha2Code: 'RS',
        alpha3Code: 'SRB',
        currencyCode: 'RSD',
        currencySymbol: 'дин.',
        callingCodes: ['381'],
    },
    SC: {
        alpha2Code: 'SC',
        alpha3Code: 'SYC',
        currencyCode: 'SCR',
        currencySymbol: '₨',
        callingCodes: ['248'],
    },
    SL: {
        alpha2Code: 'SL',
        alpha3Code: 'SLE',
        currencyCode: 'SLL',
        currencySymbol: 'Le',
        callingCodes: ['232'],
    },
    SG: {
        alpha2Code: 'SG',
        alpha3Code: 'SGP',
        currencyCode: 'BND',
        currencySymbol: '$',
        callingCodes: ['65'],
    },
    SX: {
        alpha2Code: 'SX',
        alpha3Code: 'SXM',
        currencyCode: 'ANG',
        currencySymbol: 'ƒ',
        callingCodes: ['1721'],
    },
    SK: {
        alpha2Code: 'SK',
        alpha3Code: 'SVK',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['421'],
    },
    SI: {
        alpha2Code: 'SI',
        alpha3Code: 'SVN',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['386'],
    },
    SB: {
        alpha2Code: 'SB',
        alpha3Code: 'SLB',
        currencyCode: 'SBD',
        currencySymbol: '$',
        callingCodes: ['677'],
    },
    SO: {
        alpha2Code: 'SO',
        alpha3Code: 'SOM',
        currencyCode: 'SOS',
        currencySymbol: 'Sh',
        callingCodes: ['252'],
    },
    ZA: {
        alpha2Code: 'ZA',
        alpha3Code: 'ZAF',
        currencyCode: 'ZAR',
        currencySymbol: 'R',
        callingCodes: ['27'],
    },
    GS: {
        alpha2Code: 'GS',
        alpha3Code: 'SGS',
        currencyCode: 'GBP',
        currencySymbol: '£',
        callingCodes: ['500'],
    },
    KR: {
        alpha2Code: 'KR',
        alpha3Code: 'KOR',
        currencyCode: 'KRW',
        currencySymbol: '₩',
        callingCodes: ['82'],
    },
    SS: {
        alpha2Code: 'SS',
        alpha3Code: 'SSD',
        currencyCode: 'SSP',
        currencySymbol: '£',
        callingCodes: ['211'],
    },
    ES: {
        alpha2Code: 'ES',
        alpha3Code: 'ESP',
        currencyCode: 'EUR',
        currencySymbol: '€',
        callingCodes: ['34'],
    },
    LK: {
        alpha2Code: 'LK',
        alpha3Code: 'LKA',
        currencyCode: 'LKR',
        currencySymbol: 'Rs',
        callingCodes: ['94'],
    },
    SD: {
        alpha2Code: 'SD',
        alpha3Code: 'SDN',
        currencyCode: 'SDG',
        currencySymbol: 'ج.س.',
        callingCodes: ['249'],
    },
    SR: {
        alpha2Code: 'SR',
        alpha3Code: 'SUR',
        currencyCode: 'SRD',
        currencySymbol: '$',
        callingCodes: ['597'],
    },
    SJ: {
        alpha2Code: 'SJ',
        alpha3Code: 'SJM',
        currencyCode: 'NOK',
        currencySymbol: 'kr',
        callingCodes: ['4779'],
    },
    SZ: {
        alpha2Code: 'SZ',
        alpha3Code: 'SWZ',
        currencyCode: 'SZL',
        currencySymbol: 'L',
        callingCodes: ['268'],
    },
    SE: {
        alpha2Code: 'SE',
        alpha3Code: 'SWE',
        currencyCode: 'SEK',
        currencySymbol: 'kr',
        callingCodes: ['46'],
    },
    CH: {
        alpha2Code: 'CH',
        alpha3Code: 'CHE',
        currencyCode: 'CHF',
        currencySymbol: 'Fr',
        callingCodes: ['41'],
    },
    SY: {
        alpha2Code: 'SY',
        alpha3Code: 'SYR',
        currencyCode: 'SYP',
        currencySymbol: '£',
        callingCodes: ['963'],
    },
    TW: {
        alpha2Code: 'TW',
        alpha3Code: 'TWN',
        currencyCode: 'TWD',
        currencySymbol: '$',
        callingCodes: ['886'],
    },
    TJ: {
        alpha2Code: 'TJ',
        alpha3Code: 'TJK',
        currencyCode: 'TJS',
        currencySymbol: 'ЅМ',
        callingCodes: ['992'],
    },
    TZ: {
        alpha2Code: 'TZ',
        alpha3Code: 'TZA',
        currencyCode: 'TZS',
        currencySymbol: 'Sh',
        callingCodes: ['255'],
    },
    TH: {
        alpha2Code: 'TH',
        alpha3Code: 'THA',
        currencyCode: 'THB',
        currencySymbol: '฿',
        callingCodes: ['66'],
    },
    TL: {
        alpha2Code: 'TL',
        alpha3Code: 'TLS',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['670'],
    },
    TG: {
        alpha2Code: 'TG',
        alpha3Code: 'TGO',
        currencyCode: 'XOF',
        currencySymbol: 'Fr',
        callingCodes: ['228'],
    },
    TK: {
        alpha2Code: 'TK',
        alpha3Code: 'TKL',
        currencyCode: 'NZD',
        currencySymbol: '$',
        callingCodes: ['690'],
    },
    TO: {
        alpha2Code: 'TO',
        alpha3Code: 'TON',
        currencyCode: 'TOP',
        currencySymbol: 'T$',
        callingCodes: ['676'],
    },
    TT: {
        alpha2Code: 'TT',
        alpha3Code: 'TTO',
        currencyCode: 'TTD',
        currencySymbol: '$',
        callingCodes: ['1868'],
    },
    TN: {
        alpha2Code: 'TN',
        alpha3Code: 'TUN',
        currencyCode: 'TND',
        currencySymbol: 'د.ت',
        callingCodes: ['216'],
    },
    TR: {
        alpha2Code: 'TR',
        alpha3Code: 'TUR',
        currencyCode: 'TRY',
        currencySymbol: null,
        callingCodes: ['90'],
    },
    TM: {
        alpha2Code: 'TM',
        alpha3Code: 'TKM',
        currencyCode: 'TMT',
        currencySymbol: 'm',
        callingCodes: ['993'],
    },
    TC: {
        alpha2Code: 'TC',
        alpha3Code: 'TCA',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1649'],
    },
    TV: {
        alpha2Code: 'TV',
        alpha3Code: 'TUV',
        currencyCode: 'AUD',
        currencySymbol: '$',
        callingCodes: ['688'],
    },
    UG: {
        alpha2Code: 'UG',
        alpha3Code: 'UGA',
        currencyCode: 'UGX',
        currencySymbol: 'Sh',
        callingCodes: ['256'],
    },
    UA: {
        alpha2Code: 'UA',
        alpha3Code: 'UKR',
        currencyCode: 'UAH',
        currencySymbol: '₴',
        callingCodes: ['380'],
    },
    AE: {
        alpha2Code: 'AE',
        alpha3Code: 'ARE',
        currencyCode: 'AED',
        currencySymbol: 'د.إ',
        callingCodes: ['971'],
    },
    GB: {
        alpha2Code: 'GB',
        alpha3Code: 'GBR',
        currencyCode: 'GBP',
        currencySymbol: '£',
        callingCodes: ['44'],
    },
    US: {
        alpha2Code: 'US',
        alpha3Code: 'USA',
        currencyCode: 'USD',
        currencySymbol: '$',
        callingCodes: ['1'],
    },
    UY: {
        alpha2Code: 'UY',
        alpha3Code: 'URY',
        currencyCode: 'UYU',
        currencySymbol: '$',
        callingCodes: ['598'],
    },
    UZ: {
        alpha2Code: 'UZ',
        alpha3Code: 'UZB',
        currencyCode: 'UZS',
        currencySymbol: null,
        callingCodes: ['998'],
    },
    VU: {
        alpha2Code: 'VU',
        alpha3Code: 'VUT',
        currencyCode: 'VUV',
        currencySymbol: 'Vt',
        callingCodes: ['678'],
    },
    VE: {
        alpha2Code: 'VE',
        alpha3Code: 'VEN',
        currencyCode: 'VEF',
        currencySymbol: 'Bs F',
        callingCodes: ['58'],
    },
    VN: {
        alpha2Code: 'VN',
        alpha3Code: 'VNM',
        currencyCode: 'VND',
        currencySymbol: '₫',
        callingCodes: ['84'],
    },
    WF: {
        alpha2Code: 'WF',
        alpha3Code: 'WLF',
        currencyCode: 'XPF',
        currencySymbol: 'Fr',
        callingCodes: ['681'],
    },
    EH: {
        alpha2Code: 'EH',
        alpha3Code: 'ESH',
        currencyCode: 'MAD',
        currencySymbol: 'د.م.',
        callingCodes: ['212'],
    },
    YE: {
        alpha2Code: 'YE',
        alpha3Code: 'YEM',
        currencyCode: 'YER',
        currencySymbol: '﷼',
        callingCodes: ['967'],
    },
    ZM: {
        alpha2Code: 'ZM',
        alpha3Code: 'ZMB',
        currencyCode: 'ZMW',
        currencySymbol: 'ZK',
        callingCodes: ['260'],
    },
    ZW: {
        alpha2Code: 'ZW',
        alpha3Code: 'ZWE',
        currencyCode: 'BWP',
        currencySymbol: 'P',
        callingCodes: ['263'],
    },
};
